import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';
import { normalizeGroups } from 'features/integrations/utils/integrationNormalize';

export const groupsApi = createApi({
  reducerPath: 'groupsApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['DeviceGroups'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    GetGroups: builder.query({
      query: () => ({
        url: '/getDeviceGroups_v2',
      }),
      transformResponse: (response) => normalizeGroups(response?.result || []),
      providesTags: ['DeviceGroups'], // Tells RTK Query this query provides 'Device' data and to refetch when invalidated
    }),
    createGroup: builder.mutation({
      query: (group) => ({
        url: '/addDeviceGroup_v2',
        method: 'POST',
        data: { group },
      }),
      invalidatesTags: ['DeviceGroups'], // Tells RTK Query to refetch any queries that provide this tag
    }),
    editGroup: builder.mutation({
      query: (group) => ({
        url: '/updateDeviceGroup_v2',
        method: 'POST',
        data: { group },
      }),
      invalidatesTags: ['DeviceGroups'], // Tells RTK Query to refetch any queries that provide this tag
    }),
    deleteGroup: builder.mutation({
      query: (id) => ({
        url: '/removeDeviceGroup_v2',
        method: 'POST',
        data: { id },
      }),
      invalidatesTags: ['DeviceGroups'], // Tells RTK Query to refetch any queries that provide this tag
    }),
  }),
});

export const {
  useGetGroupsQuery,
  useCreateGroupMutation,
  useEditGroupMutation,
  useDeleteGroupMutation,
} = groupsApi;
